import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnSave(props) {
  let action_id = useDataValue({
    context: 'action',
    path: 'id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  return async function save(recipient_id, postal_address_id) {
    await submit({
      type: 'set_task_action_metadata_recipient_id_and_postal_address_id',
      action_id,
      recipient_id,
      postal_address_id,
    })
  }
}
